import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject,signal} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManipulationsToolbarComponent } from 'src/app/shared/components/manipulations-toolbar/manipulations-toolbar.component';
import { ApprovalStore } from '../../store/approval-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { ApprovalsListItemComponent } from "../approvals-list-item/approvals-list-item.component";
import { ApprovalsListHeaderComponent } from "../approvals-list-header/approvals-list-header.component";
import { NoResultComponent } from "src/app/shared/components/no-result/no-result.component";
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { ApprovalsBulkActionBarComponent } from "../approvals-bulk-action-bar/approvals-bulk-action-bar.component";
import {ApprovalSort,ApprovalSortBy,SortDirection} from '../../../../models/approval.model';

@Component({
    selector: 'que-approvals-list',
    imports: [CommonModule, ManipulationsToolbarComponent, ApprovalsListItemComponent, ApprovalsListHeaderComponent, NoResultComponent, ApprovalsBulkActionBarComponent],
    templateUrl: './approvals-list.component.html',
    styleUrls: ['./approvals-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApprovalsListComponent {
  #approvalStore = inject(ApprovalStore);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
readonly sort = signal<ApprovalSort>({
  sortBy: ApprovalSortBy.SenderName,
  sortDirection: SortDirection.Asc,
});
  approvals$ = toSignal(this.#approvalStore.approvals$)
  loading$ = toSignal(this.#approvalStore.loading$);
  loadingExtra$ = toSignal(this.#approvalStore.loadingExtra$);
  isEmpty$ = toSignal(this.#approvalStore.isEmpty$);
  isResult$ = toSignal(this.#approvalStore.totals$.pipe(map(x => x != undefined && x > 0)));
  isFilterListOpen$ = toSignal(this.#manipulationsToolbarStore.isFilterListOpen$);
  approvalsExtra$ = toSignal(this.#approvalStore.approvalsExtra$);
  pendingApprovalTab$ = toSignal(this.#manipulationsToolbarStore.pendingApprovalTab$);
  constructor(private el: ElementRef) {
  }

  @HostListener('document:mousewheel', ['$event'])
  onWindowScroll(event: any) {
    const scrollContainer = this.el.nativeElement.querySelector('.scroll');
    if (scrollContainer) {
      const scrollBottom = scrollContainer.scrollHeight - scrollContainer.clientHeight;
      if (scrollContainer.scrollTop >= scrollBottom - 1) {
        var is10InExtra = this.approvalsExtra$()?.result.length == 10;
        if (this.approvalsExtra$()?.result && this.approvalsExtra$()!.result.length > 0) {
          this.#approvalStore.updateApprovalWithExtra();
        }
        if (this.approvalsExtra$() && is10InExtra && !this.loadingExtra$())
          this.loadMore();
      }
    }
  }
onSortChange(sortBy: ApprovalSortBy): void {
  const currentSort = this.sort();

  const sortDirection =
    currentSort.sortBy === sortBy
      ? currentSort.sortDirection === SortDirection.Asc
        ? SortDirection.Desc
        : SortDirection.Asc
      : SortDirection.Asc;

  const newSort: ApprovalSort = {
    sortBy,
    sortDirection,
  };

  this.sort.set(newSort);
  this.#approvalStore.changeSort(newSort);
}
  loadMore() {
    this.#approvalStore.loadApprovalsExtra();
  }
}
